import React, { Component } from 'react';
import { Spinner } from 'reactstrap';


class Loading extends Component {
  render() {
    return (
      <div className="container">
        <h1 className="text-center"> Loading <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} /> </h1>
        <br></br>
        <br></br>
        <h1 className="text-center"> <img width="410" height="410" src={<i class="fas fa-car"></i>} alt=""/></h1>
      </div>
    );
  }
}

export default Loading;